import { forwardRef, memo } from "react"
import type { FC, ForwardedRef, NamedExoticComponent, ReactElement } from "react"

import { propsAreEqual } from "@/3514/utils"

import { FreeResponsesProvider as Provider } from "./free-responses.context"
import type { TFreeResponsesConfig as TConfig, TFreeResponsesEntityRef as TEntityRef } from "./free-responses.types"

type TProps = TConfig & {}

const Entity: FC<TProps> = forwardRef<TEntityRef, TProps>(
    (props: TProps, ref: ForwardedRef<TEntityRef>): ReactElement => <Provider {...props} {...{ ref }} />
)

Entity.displayName = "FreeResponsesEntity"

const MemoizedEntity: NamedExoticComponent<TProps> = memo<TProps>(Entity, propsAreEqual<TProps>)

export { MemoizedEntity as FreeResponsesEntity }
